import { Action, OperationType, WindowType } from '../../dispatcher/Types';
import {
  APP_SETTINGS
} from '../../dispatcher/authentication/services/AuthSettings';

/**
 * Auth server signIn request
 */
export const signInRequest: Action = [{
  moduleName: 'AuthService',
  name: 'runService'
}, {
  args: ['state'],
  moduleName: 'AuthService',
  name: 'signIn'
}];

/**
 * Auth server signedIn redirect callback
 * This will handle user management after user has been successfully signed in
 */
export const signedInRedirectCallback: Action = [{
  moduleName: 'AuthService',
  name: 'runService'
}, {
  isCallback: false,
  isPromise: true,
  handleError: true,
  moduleName: 'AuthService',
  name: 'signInRedirectCallback'
}, {
  name: 'setLandingUri',
  type: OperationType.action
}];

/**
 * User login request
 * This will handle user management for local user sessions
 */
export const loginRequest: Action = [{
  data: {
    template: {
      isAuthRest: true,
      method: 'post',
      url: '/oauth/token',
      params: {
        bind: {
          username: '{username}',
          password: '{password}'
        },
        grant_type: 'password'
      }
    }
  },
  mappingName: 'userResponse',
  type: OperationType.request
}, {
  independent: true,
  data: {
    template: {
      bind: {
        badCredentials: '!!{userResponse.badCredentials} || {userResponse.isRequestError}'
      }
    }
  },
  type: OperationType.data
}, {
  independent: true,
  moduleName: 'LoginPage',
  name: 'updateBadCredentialsMessage',
  args: ['badCredentials']
}, {
  condition: '!{badCredentials}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          user: '{userResponse}'
        }
      }
    },
    moduleName: 'AuthService',
    name: 'storeLocalUser',
    args: ['user']
  }, {
    isCallback: false,
    isPromise: true,
    handleError: true,
    moduleName: 'AuthService',
    name: 'isAuthenticated',
    type: OperationType.addOperationData
  }, {
    name: 'setLandingUri',
    type: OperationType.action
  }, {
    name: 'runAuthProvider',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

/**
 * Test if user session is local
 */
export const getRefreshToken: Action = [{
  data: {
    template: {
      bind: {
        refresh_token: '{user} && _.get({user}, "refresh_token")'
      }
    }
  },
  type: OperationType.data
}, {
  persistent: ['refresh_token'],
  type: OperationType.addPersistentData
}, {
  items: ['refresh_token'],
  type: OperationType.syncDispatchersDataItem
}];

/**
 * Auth server silent signin request
 * This will handle user token management and provide a new access token for the user
 */
export const signinSilent: Action = [{
  moduleName: 'AuthService',
  name: 'runService'
}, {
  moduleName: 'AuthService',
  name: 'signinSilentRequest'
}];

/**
 * Auth server silent signin callback
 * This will handle user token management and provide a new access token for the user
 */
export const signInSilentCallback: Action = [{
  moduleName: 'AuthService',
  name: 'runService'
}, {
  isCallback: false,
  isPromise: true,
  moduleName: 'AuthService',
  name: 'signInSilentCallback'
}];

/**
 * Retry silentSignin/token refresh
 */
export const signinSilentRetry: Action = [{
  isCallback: false,
  isPromise: true,
  moduleName: 'AuthService',
  name: 'isAuthenticated',
  type: OperationType.addOperationData
}, {
  condition: '{refresh_token}',
  conditionOperations: [{
    isCallback: false,
    isPromise: true,
    name: 'refreshToken',
    moduleName: 'AuthService'
  }],
  elseOperations: [{
    name: 'signinSilent',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  isCallback: false,
  isPromise: true,
  moduleName: 'AuthService',
  name: 'isAuthenticated',
  type: OperationType.addOperationData
}, {
  condition: '{user} && {isAuthenticated}',
  conditionOperations: [{
    windowType: WindowType.warning,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}];

/**
 * Redirect user to authorization server login page
 */
export const redirectToSignIn: Action = [{
  moduleName: 'AuthService',
  name: 'runService'
}, {
  data: {
    path: APP_SETTINGS.signin_uri
  },
  type: OperationType.redirect
}];
